// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-Achievement-Chain-chain__container--2PrYU{padding:8px 16px 64px}\n", ""]);
// Exports
exports.locals = {
	"container": "src-routes-App-components-Achievement-Chain-chain__container--2PrYU"
};
module.exports = exports;
